<template>
  <div class="horizontal-container" :style="{ height: `${innerHeight}px` }">
    <section
      :id="section.id"
      v-for="(section, index) of sectionList"
      :key="section.id"
      class="section horizontal-section"
      :class="section.type == 'gallery' ? 'section-large' : section.beforeGallery ? 'before-gallery' : ''"
    >
      <component
        :is="`section-${section.type}`"
        :content="section"
        :animated="false"
        :allowReverseScroll="allowReverseScroll(sectionList, index)"
        @next-section="$emit('next-section', index)"
        @previous-section="$emit('previous-section', index)"
      />
    </section>
  </div>
</template>

<style scoped>
.horizontal-container {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  flex-shrink: 0;
}
</style>

<script>
import SectionSound from "../sections/SectionSound";
import MobileGallerySection from "../sections/SectionGallery/MobileGallerySection";
import TheLoadingScreen from "../loading-screen/TheLoadingScreen";
import TheLanguageSwitcher from "../language-switcher/TheLanguageSwitcher";
import TheLanguageSwitcherScreen from "../language-switcher/TheLanguageSwitcherScreen";
import SectionText from "../sections/SectionText";
import SectionImageRedirect from "../sections/SectionImageRedirect";
import SectionTextRedirect from "../sections/SectionTextRedirect";
import SectionGallery from "../sections/SectionGallery/SectionGallery";
import BackgroundRedConcrete from "../section-backgrounds/RedConcrete";
import PlayButton from "../play-button/PlayButton.vue";
export default {
  data() {
    return {
      innerHeight: window.innerHeight,
    };
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  },

  props: {
    sectionList: {
      type: Array,
      required: true,
    },
  },

  components: {
    "section-gallery": MobileGallerySection,
    SectionSound,
    TheLoadingScreen,
    TheLanguageSwitcher,
    TheLanguageSwitcherScreen,
    SectionText,
    SectionImageRedirect,
    SectionTextRedirect,
    BackgroundRedConcrete,
    SectionGallery,
    PlayButton,
  },
  methods: {
    handleResize() {
      this.innerHeight = window.innerHeight;
    },
    allowReverseScroll(list, index) {
      return index > 0 && index < list.length - 1;
    },
  },
};
</script>